"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  NEW_MSG_TAB_TITLE: "New chat message",
  DEFAULT_DOCUMENT_TITLE: "Chat to us online",
  DEFAULT_DOCUMENT_DESCRIPTION: "Chat to our bot, or connect with one of our human team members for more help."
};